exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.left {\n  border-radius: 6px 0px 0px 6px;\n  margin-right: 1px;\n}\n.left.secondary-theme {\n  margin-right: 0;\n}\n.mp-sharing-status-button-container {\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n.fully-rounded {\n  border-radius: 6px;\n}\n", ""]);

// exports
